<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-users-rectangle"></i></div>
      <div>
        Enseignant et classe
        <div class="page-title-subheading">Affectation des enseignants aux classes</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
   

    <div class="row">
        <div class="col-lg-12">
            <div class="card">
              
                <div class="card-body">
                    <ul class="nav nav-tabs nav-justified mb-3">
                        <li class="nav-item">
                       <a role="tab" class="nav-link active" id="tab-c1-0" data-bs-toggle="tab" data-bs-target="#tab-animated1-0" href="#tab-animated1-0" aria-selected="true">
                       <span class="nav-text">Assignation de classe</span>
                       </a>
                       </li>
                       <li class="nav-item">
                       <a role="tab" class="nav-link" id="tab-c1-1" data-bs-toggle="tab" data-bs-target="#tab-animated1-1" href="#tab-animated1-1" aria-selected="false">
                       <span class="nav-text">Liste des professeurs par classe</span>
                       </a>
                       </li>
                       </ul>
                       <div class="tab-content">
                        <div class="tab-pane  p-3 active" id="tab-animated1-0" role="tabpanel">
                            <div class="d-flex justify-content-between mb-5">
                                <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Assigner des classes
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                                    <button *ngIf="data.length!=0" (click)="getPdf()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                        Exporter en PDF</button>
                                </div>
            
                                <div class="form-group ms-auto">
                                    <label for=""> <strong>Rechercher:</strong> </label>
                                    <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                                </div>
                            </div>
            <p>{{data!.length}} élément(s)</p>
            <div class="table-responsive">
            <table class="table" >
                <thead class="">
                    <tr>
                        <th style="width: 10px;">#</th>
                        <th>Nom et prénom(s)</th>
                        <th>Classe(s) gardée(s)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'professors-classrooms' | paginate: {
                        id:'ngxP1',
                    itemsPerPage: pg.pageSize,
                    currentPage: pg.p,
                    totalItems: pg.total } ">
                        <td>
                            <div class="form-check mb-2">
                                <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                            
                            </div>
                        </td>
                        <td>{{d.lastname}} {{d.firstname}}</td>
                        <td>
                            <ul>
                                <li *ngFor="let pac of d.pacs">{{pac?.classroom?.name}}
                                    <i class="fa fa-times text-danger pointer ms-1" (click)="removeClassroom(pac.id)"></i>
                                </li>
                            </ul>
                        </td>
                    </tr>
                
                </tbody>
            </table>
            </div>
            <pagination-controls 
            id="ngxP1"
            (pageChange)="getPage($event)"
          [maxSize]="9"
          [directionLinks]="true"
          [autoHide]="true"
          [responsive]="true"
          [previousLabel]="'Previous'"
          [nextLabel]="'Next'"
          [screenReaderPaginationLabel]="'Pagination'"
          [screenReaderPageLabel]="'page'"
          [screenReaderCurrentLabel]="'You\'re on page'">
         </pagination-controls>
                        </div>
                        <div class="tab-pane p-3" id="tab-animated1-1" role="tabpanel">
                            <div class="row align-items-end mb-3">
                                <div class="col-12 col-md-4">
                                    <label for="classroom_pick" class="form-label mb-0"><strong>Classe</strong></label>
                                    <ng-select id="classroom_pick" (change)="loadProfessors($event)"
                                               [clearable]="false" placeholder="Choisir une classe">
                                        <ng-option *ngFor="let cl of classrooms" [value]="cl.id">{{cl.name}}</ng-option>
                                    </ng-select>
                                </div>
                                <div class="col-12 col-md-8 text-md-end mt-2 mt-md-0">
                                    <!-- Cette action porte sur la ligne selectionnee. -->
                                    <button *ngIf="selected_data" (click)="setPrincipal()" type="button"
                                            class="btn btn-sm btn-warning"
                                            title="Designer l'enseignant selectionne comme principal">
                                        <i class="fa-solid fa-star me-1" aria-hidden="true"></i>Définir comme professeur principal
                                    </button>
                                    <span class="text-muted small" *ngIf="!selected_data">
                                        Sélectionnez un enseignant pour le désigner comme principal.
                                    </span>
                                </div>
                            </div>

                            <p>{{data2.length}} élément(s)</p>
                            <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 10px;"></th>
                                        <th style="width: 40px;">#</th>
                                        <th>Nom et prénom(s)</th>
                                        <th>Statut</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data2; let i=index">
                                        <td>
                                            <div class="form-check mb-2">
                                                <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault2">
                                            </div>
                                        </td>
                                        <td>{{i+1}}</td>
                                        <td>{{d.professor?.lastname}} {{d.professor?.firstname}}</td>
                                        <td>
                                            <span *ngIf="d.is_principal" class="badge bg-primary">Enseignant principal</span>
                                            <span *ngIf="!d.is_principal" class="badge bg-secondary">Enseignant</span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="data2.length===0">
                                        <td colspan="4" class="text-center text-muted py-3">
                                            Choisissez une classe pour afficher ses enseignants.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                
</div>
</div>
</div>
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer un professeur</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Enseignant <span class="text-danger ml-2">(*)</span></label>
                <select class="form-control" name="professor_id" [(ngModel)]="professor_id" id="">
                    <option *ngFor="let p of professors" [value]="p.id">{{p.lastname}} {{p.firstname}}</option>
                </select>
            </div>
            <div class=" form-group col-12 mb-3">
                    <label for="">Classe</label>
                    <ng-select [multiple]="true" [(ngModel)]="selectedClassrooms" name="selectedClassrooms">
                        <ng-option *ngFor="let c of classrooms" [value]="c.id">{{c.name}}</ng-option>
                     </ng-select>
            </div>
      
        </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>
